import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../reducers'
import { selectBrands } from '../../../../reducers/promos'

interface BrandOption {
    name: string;
    value: string | null;
}

const allBrandsIndicator = 'everywhere'

export default function useDisplayBrands(): BrandOption[] {
    const brands = useAppSelector(selectBrands)
    const { t } = useTranslation()
    
    return React.useMemo(() => {
        const emptyBrand = {
            name: t('promo-brand-none'),
            value: null,
        } as BrandOption

        const displayBrands = brands.sort((a, b) => {
            if (a.name.toLowerCase() === allBrandsIndicator) {
                return -1
            }

            if (b.name.toLowerCase() === allBrandsIndicator) {
                return 1
            }

            return a.name.localeCompare(b.name)
        }).map((brand) => {
            if (brand.name.toLowerCase() === allBrandsIndicator) {
                return {
                    name: t('promo-brand-all'),
                    value: allBrandsIndicator,
                } as BrandOption
            }

            return {
                name: brand.name,
                value: brand.name,
            }
        })

        return [emptyBrand, ...displayBrands]
    }, [brands, t])
}
